<template>
  <v-dialog persistent :max-width="width" v-model="dialog">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-subtitle class="subtitle-1 pt-1" v-if="subtitle">
        {{ subtitle }}
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="accent" @click="handleClose">Cancel</v-btn>
        <v-btn text color="primary" @click="handleComplete">
          {{ confirmationBtnText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const CONFIRM_BTN_TEXT = 'Confirm';
const DEFAULT_DIALOG_MAX_WIDTH = 320;

export default {
  data() {
    return {
      dialog: false,
      title: '',
      subtitle: '',
      confirmationBtnText: CONFIRM_BTN_TEXT,
      width: DEFAULT_DIALOG_MAX_WIDTH
    };
  },
  methods: {
    open({
      title,
      subtitle,
      confirmationBtnText = CONFIRM_BTN_TEXT,
      width = DEFAULT_DIALOG_MAX_WIDTH
    }) {
      this.dialog = true;
      this.title = title;
      this.subtitle = subtitle;
      this.confirmationBtnText = confirmationBtnText;
      this.width = width;
    },
    handleClose() {
      this.dialog = false;
      this.$emit('onCancel');
    },
    handleComplete() {
      this.handleClose();
      this.$emit('onConfirm');
    }
  }
};
</script>
